import { bindUrl, request } from "./request";
/**
 * app授权登录
 */
export function appAuto(bodyParams) {
  return request({
    // url: bindUrl("/oil/app/authorize/appAuto", {}),
    url: bindUrl("/oil/app/client/appAutoLogin", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * app短信验证码授权登录
 */
export function appLogin(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/message/appLogin", {}),
    method: "POST",
    data: bodyParams
  });
}
